<template>
  <div class="container">
    <div class="monitor" :style="{width: fullWidth+'px', height: monitorHeight+'px'}">
      <fetal-monitor ref="fm" v-for="(item, index) in monitorViews.filter(o=>{return !o.hidden})"
                     :key="item.data.userId + '@' + item.data.userType"
                     :index="index"
                     :x="item.x"
                     :y="item.y"
                     :top="item.top"
                     :right="item.right"
                     :width="item.width"
                     :height="item.height"
                     :cm="config.cm"
                     :bed-mode="pagination.pageSize"
                     :data="item.data"
                     @tocoReset="tocoReset">
      </fetal-monitor>
    </div>
    <div class="copyright" :style="{'--height' : copyrightHeight + 'px'}">
      <div class="company">{{ $t('mainView.name') }}</div>
      <div class="paging">
        <el-pagination
          layout="prev, pager, next"
          :hide-on-single-page="(Math.ceil(pagination.total / pagination.pageSize ) <= 1)"
          :page-size="pagination.pageSize"
          :current-page="pagination.currentPage"
          :total="pagination.total"
          @current-change="currentPageChange">
        </el-pagination>
      </div>
      <div class="tools">
        <el-tooltip effect="dark" :content="$t('mainView.onlineUser')" placement="top-end">
          <svg-icon icon-class="userlist" :class-name="showMsgRemindAnim ? 'user-list' : ''"
                    @click="openUserList"></svg-icon>
        </el-tooltip>
        <el-tooltip effect="dark" :content="$t('mainView.sysSet')" placement="top-end">
          <svg-icon icon-class="setting" @click="openSetting"></svg-icon>
        </el-tooltip>
        <el-tooltip effect="dark" :content="$t('mainView.refresh')" placement="top-end">
          <svg-icon icon-class="refresh" @click="refresh"></svg-icon>
        </el-tooltip>
        <el-tooltip effect="dark" :content="tools.fullScreen ? $t('mainView.exitFs') : $t('mainView.fs')" placement="top-end">
          <svg-icon :icon-class="tools.fullScreen ? 'fullscreen-shrink' : 'fullscreen-expand'"
                    @click="fullscreen"></svg-icon>
        </el-tooltip>
      </div>
    </div>
    <el-drawer
      :title="tools.drawer.drawerTitle"
      :visible.sync="tools.drawer.drawer"
      :direction="tools.drawer.direction"
      :before-close="closeSetting">
      <span>
        <user-list
          v-if="tools.drawer.contentType === 1"
          :users="getOnlineUsers()"
          @rowClick="rowClick"
          @openChat="openChat"
          @openContact="openContact"
          @refreshCurrentContact="refreshCurrentContact"></user-list>
        <settings
          v-if="tools.drawer.contentType === 2"
          v-on:saveSettings="saveSettings"></settings>
      </span>
    </el-drawer>
    <monitor-service ref="monitorService" @onMessage="onMessage"></monitor-service>
    <chat-message ref="chatMessage"
                  @onMessage="onChatSendMessage"
                  @onFillMessage="onFillMessage"
                  @getUserInfo="getUserInfo"></chat-message>
    <contact-info ref="contactInfo"></contact-info>
    <i-m-view v-if="im.isLoad"
              v-show="im.isShow"
              ref="im"
              @onClosed="imClosed"
              @onNewMessage="imNewMessage"
    ></i-m-view>
  </div>
</template>

<script>

import {debounce} from '../common/common'
import ScreenFull from 'screenfull'
import LayoutConfig from '../common/layout-config'
import SettingStorage from '../common/setting-storage'
import Settings from './Settings'
import FetalMonitor from './FetalMonitor'
import MonitorService from './MonitorService'
import ChatMessage from './ChatMessage'
import DrawWorker from '../common/draw.worker'
import UserList from './UserList'
import ContactInfo from './ContactInfo'
import IMView from './IMView'

export default {
  name: 'MainView',
  components: {FetalMonitor, Settings, MonitorService, ChatMessage, UserList, ContactInfo, IMView},
  data () {
    return {
      // 用户信息
      users: [],
      // 页面可视区域宽度
      fullWidth: 0,
      // 页面可视区域高度
      fullHeight: 0,
      // 监护窗口边框
      border: 0,
      // 监护容器高度
      monitorHeight: 0,
      // 监护视图缓存
      monitorViews: [],
      // 工具栏高度
      copyrightHeight: 30,
      // 工具栏配置
      tools: {
        drawer: {
          drawer: false,
          direction: 'rtl',
          drawerTitle: '',
          contentType: 0
        },
        fullScreen: false
      },
      // 分页配置
      pagination: {
        currentPage: 1,
        pageSize: 0,
        pageCount: 0,
        total: 0
      },
      config: {
        cm: 0
      },
      throttleFunc: null,
      debounceFunc: null,
      showMsgRemindAnim: false,
      im: {
        isLoad: false,
        isShow: false
      }
    }
  },
  watch: {
    fullHeight (val) {
      this.fullHeight = val
      this.monitorHeight = val - this.copyrightHeight
    }
  },
  created () {
    this.loadParams()
    this.getViewportSize()
    // this.initUser(this.blankUsers())
    this.initUser([])
    this.initOffscreen()
    this.loadView()
    // this.startReceiveData()
    // this.prepareData()
  },
  mounted () {
    const that = this
    window.onresize = () => {
      // that.resize()
      // if (!this.throttleFunc) {
      //   this.throttleFunc = throttle(that.resize, 500, 1000)
      // }
      // this.throttleFunc()

      if (!this.debounceFunc) {
        this.debounceFunc = debounce(that.resize, 300)
      }
      this.debounceFunc()
    }
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') {
        // 页面可见
        // 360浏览器极速模式很容易出现canvas内容丢失
        // 如果最小化和最大化间隔时间久远？自动刷一下？
        // that.loadView()
        if (that.$refs.fm) {
          const length = that.$refs.fm.length
          for (let i = 0; i < length; i++) {
            const item = that.$refs.fm[i]
            if (!item.hidden) {
              that.drawWorker.postMessage({
                cmd: 'reDraw',
                args: {userId: item.data.userId, userType: item.data.userType}
              })
            }
          }
        }
      }
      if (document.visibilityState === 'hidden') {
        // 页面不可见
      }
    })

    this.connect()

    if (ScreenFull.isEnabled) {
      ScreenFull.on('change', () => {
        that.tools.fullScreen = ScreenFull.isFullscreen
      })
    }
  },
  methods: {
    loadParams () {
      const params = SettingStorage.get()
      if (params) {
        this.config.cm = params.cm
        this.pagination.pageSize = params.bedMode
      }
    },
    initUser (users) {
      this.users = users
      this.pagingCompute()
    },
    pagingCompute () {
      this.pagination.pageCount = Math.ceil(this.users.length / this.pagination.pageSize)
      if (this.pagination.currentPage > this.pagination.pageCount) {
        this.pagination.currentPage = 1
      }
      this.pagination.total = this.users.length
    },
    computePageViewQuantity () {
      if (this.pagination.currentPage === this.pagination.pageCount) {
        const n = this.pagination.total % this.pagination.pageSize
        if (n > 0) {
          return n
        }
      }
      return this.pagination.pageSize
    },
    loadView () {
      if (this.users.length === 0) return

      const quantity = this.pagination.pageSize
      const cellQuantity = LayoutConfig(quantity).singleRow
      const size = this.computePageViewQuantity()
      this.monitorViewCacheResize(size)

      const rows = Math.ceil(this.pagination.pageSize / cellQuantity)
      let startIndex = (this.pagination.currentPage - 1) * this.pagination.pageSize
      let i = 0
      let manualViews = []
      for (; i < size; i++) {
        const user = this.users[startIndex + i]
        this.monitorViews[i].data = user
        this.$set(this.monitorViews, i, this.monitorViews[i])
        // eslint-disable-next-line no-unused-vars
        let width, height
        // const rowIndex = parseInt(i / this.cellQuantity + 1, 10)
        const cellIndex = i % cellQuantity
        width = (this.fullWidth - this.border * (cellQuantity - 1)) / cellQuantity
        height = (this.fullHeight - this.copyrightHeight - this.border * (rows - 1)) / rows
        const view = this.contain(i)
        // eslint-disable-next-line one-var
        let right = 0, top = 0
        if (cellIndex !== cellQuantity - 1) {
          right = this.border
        }
        // if (rowIndex !== 1) {
        //   top = this.border
        // }
        if (view !== null) {
          view.width = width
          view.height = height
          view.top = top
          view.right = right
          manualViews.push(view)
        } else {
          console.log('@@@【view is null】')
        }
      }

      const settings = SettingStorage.get()

      const that = this
      this.$nextTick(() => {
        manualViews.filter(o => !o.hidden || o.hidden === false).forEach(function (item, index) {
          const fmView = that.$refs.fm[index]
          const data = item.data
          fmView.resize()
          that.drawWorker.postMessage({
            cmd: 'add',
            args: {
              userId: data.userId,
              userType: data.userType,
              cm: settings.cm,
              bedMode: that.pagination.pageSize,
              settings: settings,
              deviceRatio: window.devicePixelRatio,
              data: data
            }
          })

          that.drawWorker.postMessage({
            cmd: 'resize',
            // eslint-disable-next-line standard/object-curly-even-spacing
            args: {
              userId: data.userId,
              userType: data.userType,
              width: item.width,
              height: item.height - fmView.getHeaderHeight(),
              // TODO::有时会出现FetalMonitor的Canvas未创建情况，怀疑是resize不强制，导致某些情况下没有创建
              isForce: true
            }
          })
        })
      })
    },
    /**
     * 根据监护窗口数量需求你，重置views缓存大小
     * */
    monitorViewCacheResize (size) {
      let viewCount = this.monitorViews.length
      const count = size - viewCount
      if (count > 0) {
        let i = 0
        for (; i < count; i++) {
          this.monitorViews.push({
            index: viewCount + i,
            width: 0,
            height: 0,
            top: 0,
            right: 0
          })
        }
      } else {
        let max = viewCount - 1
        for (; max >= size; max--) {
          const item = this.monitorViews[max]
          if (!item.hidden) {
            item.hidden = true
            this.drawWorker.postMessage({
              cmd: 'remove',
              args: {userId: this.$refs.fm[max].data.userId, userType: this.$refs.fm[max].data.userType}
            })
          }
        }
      }

      let i = 0
      for (; i < size; i++) {
        if (this.monitorViews[i].hidden) {
          this.monitorViews[i].hidden = false
        }
      }
    },
    contain (index) {
      let i = 0
      for (; i < this.monitorViews.length; i++) {
        if (this.monitorViews[i].index === index) {
          return this.monitorViews[i]
        }
      }

      return null
    },
    getViewportSize () {
      this.fullWidth = document.documentElement.clientWidth
      this.fullHeight = document.documentElement.clientHeight
    },
    resize () {
      this.getViewportSize()
      this.loadView()
    },
    refresh () {
      this.$confirm(this.$t('mainView.confirmRefresh'))
        .then(_ => {
          this.loadView()
          this.$message({
            message: this.$t('mainView.refreshSuccess'),
            type: 'success'
          })
        })
        .catch(_ => {
        })
    },
    openUserList () {
      this.showMsgRemindAnim = false
      this.tools.drawer.drawerTitle = this.$t('mainView.onlineUser')
      this.tools.drawer.contentType = 1
      this.tools.drawer.drawer = true
      this.playAudio(false)
    },
    openSetting () {
      this.tools.drawer.drawerTitle = this.$t('mainView.sysSet')
      this.tools.drawer.contentType = 2
      this.tools.drawer.drawer = true
    },
    closeSetting (done) {
      done()
      this.$refs.chatMessage.closeChat()
      this.showMsgRemindAnim = false
    },
    fullscreen () {
      if (!ScreenFull.isEnabled) {
        this.$notify.error({
          title: '温馨提示',
          message: '您的浏览器无法使用全屏功能，请更换谷歌浏览器或者请手动点击F11按钮全屏展示。',
          position: 'top-right'
        })

        return false
      }
      ScreenFull.toggle()
      this.tools.fullScreen = !ScreenFull.isFullscreen
    },
    currentPageChange (currentPage) {
      this.pagination.currentPage = currentPage
      this.loadView()
    },
    saveSettings (data) {
      // if (window._isInElectron) {
      //   window._crash()
      // }

      let isRedraw = data.bedMode !== this.pagination.pageSize

      if (isRedraw) {
        // 床位结构发生变化
        this.pagination.pageSize = data.bedMode
        if (this.users && this.users.length > 0 && this.users[0].occupy) {
          // this.initUser(this.blankUsers())
          this.initUser([])
        } else {
          this.pagingCompute()
        }
        this.loadView()
      }

      if (this.$refs.fm) {
        // eslint-disable-next-line one-var
        let i = 0, count = this.$refs.fm.length
        const isRedrawn = isRedraw
        for (; i < count; i++) {
          const fmView = this.$refs.fm[i]
          fmView.paramChange(isRedrawn, data)
          this.drawWorker.postMessage({
            cmd: 'paramChange',
            args: {userId: fmView.data.userId, userType: fmView.data.userType, isRedrawn: isRedrawn, data: data}
          })
        }
      }
      if (!data.alarm.fhrRange) {
        this.playAlarmAudio(false)
      }

      this.tools.drawer.drawer = false
    },
    // startReceiveData () {
    //   this.receiverTimer = self.setInterval(this.receiveData, 1000)
    // },
    // stopReceiveData () {
    //   if (this.receiverTimer) {
    //     clearInterval(this.receiverTimer)
    //   }
    // },
    // receiveData () {
    //   if (this.pointCounter >= this.simulationData.length) {
    //     console.log('@@@监护结束了')
    //     return
    //   }
    //
    //   // 模拟刷新页面后，补发大量数据，再继续实时情况
    //   if (!this.reissue) {
    //     this.reissueTest()
    //     this.reissue = true
    //     console.log('@@@补发数据')
    //   }
    //   // 模拟给所有在线用户发送数据
    //   const data = JSON.stringify(
    //     [this.simulationData[this.pointCounter - 1],
    //       this.simulationData[this.pointCounter],
    //       this.simulationData[this.pointCounter + 1],
    //       this.simulationData[this.pointCounter + 2]])
    //   // 模拟接收缓存数据
    //   const usersLength = this.users.length
    //   for (let i = 0; i < usersLength; i++) {
    //     this.users[i].points = this.users[i].points.concat(JSON.parse(data))
    //   }
    //
    //   // 模拟绘制
    //   const size = this.$refs.fm.length
    //   for (let i = 0; i < size; i++) {
    //     /**
    //      * 服务器是没有做数据的存储以及灵活的补发机制，所以目前方案：
    //      * 1、在线用户有A、B、C、D...若干用户，则数据全接收，模拟测试时可以按1000人试试；
    //      * 2、被选中的用户，连接未断情况下，会持续存储数据在内存，以便重绘；
    //      * 3、如果连接断了，所有用户需要重新请求，需要完全补发后，再继续实时数据接收和处理；
    //      * */
    //     const fmView = this.$refs.fm[i]
    //     fmView.receiveData(JSON.parse(data))
    //     this.drawWorker.postMessage({
    //       cmd: 'receiveData',
    //       args: {userId: fmView.data.userId, userType: fmView.data.userType, data: JSON.parse(data), hasMove: true, display: true}
    //     })
    //   }
    //   this.pointCounter += Global.samplingRate
    // },
    // prepareData (startIndex) {
    //   // 模拟测试数据
    //   // TODO::不同用户模拟不同真实数据
    //   if (!startIndex) {
    //     startIndex = 0
    //   }
    //   const data = getMonitorData()
    //   this.simulationData = []
    //   this.pointCounter = 1
    //   const length = parseInt(parseInt(data.length / 10, 10) / 4, 10) * 4 * 10
    //   for (let i = 0; i < length; i += 10) {
    //     this.simulationData.push({
    //       index: startIndex + this.pointCounter,
    //       fhr1: data[i],
    //       fhr2: data[i + 1],
    //       toco: data[i + 3],
    //       fm: data[i + 5] === 1,
    //       autoFM: data[i + 6] === 1,
    //       tocoReset: data[i + 9] === 1
    //     })
    //     this.pointCounter++
    //   }
    //   this.pointCounter = 1
    // },
    // reissueTest () {
    //   // 模拟接收缓存数据
    //   const usersLength = this.users.length
    //   for (let i = 0; i < usersLength; i++) {
    //     this.users[i].points = this.users[i].points.concat(JSON.parse(JSON.stringify(this.simulationData)))
    //   }
    //   const size = this.$refs.fm.length
    //   for (let i = 0; i < size; i++) {
    //     // TODO::传递的数据可能会很大，需要优化！！！
    //     const fmView = this.$refs.fm[i]
    //     fmView.reDrawWave()
    //     this.drawWorker.postMessage({cmd: 'reDrawWave', args: {userId: fmView.data.userId, userType: fmView.data.userType, data: fmView.data.points}})
    //   }
    //   this.pointCounter = 1
    //   this.prepareData(this.simulationData.length)
    // },
    // cacheMonitorData (userId, userType, points) {
    //   for (let i = 0; i < this.users.length; i++) {
    //     if (this.users[i].userId === userId && this.users[i].userType === userType) {
    //       this.users[i].points = this.users[i].points.concat(JSON.parse(points))
    //       return
    //     }
    //   }
    // },
    // random (minNum, maxNum) {
    //   switch (arguments.length) {
    //     case 1:
    //       return parseInt(Math.random() * minNum + 1, 10)
    //     case 2:
    //       return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10)
    //     default:
    //       return 0
    //   }
    // },
    initOffscreen () {
      const that = this
      this.drawWorker = new DrawWorker()
      this.drawWorker.onmessage = function (e) {
        // console.log('receive worker data:: ', e.data)
        const data = e.data
        const size = that.$refs.fm.length
        for (let i = 0; i < size; i++) {
          const item = that.$refs.fm[i]
          if (item.data.userId === data.args.userId && item.data.userType === data.args.userType) {
            if (data.cmd === 'onImage') {
              item.onImage(data.args.data)
            } else if (data.cmd === 'onResize') {
              item.onResize(data.args.width, data.args.height)
            } else if (data.cmd === 'onMoveScroll') {
              item.onMoveScroll(data.args.hasMove, data.args.x)
            }
            return
          }
        }
      }
      this.drawWorker.onerror = function (e) {
        console.log([
          'ERROR: Line ', e.lineno, ' in ', e.filename, ': ', e.message
        ].join(''))
      }
    },
    tocoReset (userId, userType) {
      this.$refs.monitorService.tocoReset(userId, userType)
    },
    onMessage (args) {
      if (args.cmd === 'userList') {
        const users = this.$refs.monitorService.getOnlineUsers()
        if (users.length === 0) {
          // if (this.users[0].occupy) {
          //   return
          // }
          this.showBlankUserNotify()
          // this.initUser(this.blankUsers())
          this.monitorViews.splice(0, this.monitorViews.length)
          this.initUser([])
          // 如果用户全部下线了，新消息提醒的声音和闪烁效果停掉
          this.playAudio(false)
          this.showMsgRemindAnim = false
        } else {
          this.closeBlankUserNotify()
          this.initUser(users)
          if (!this.$refs.monitorService.existUnReadMessage()) {
            this.playAudio(false)
            this.showMsgRemindAnim = false
          }
        }
        this.loadView()
        this.checkAlarm()
      } else if (args.cmd === 'fhrData') {
        this.receiveData(args.args)
      } else if (args.cmd === 'msgReceipt') {
        this.$refs.chatMessage.refresh(args.args)
      } else if (args.cmd === 'msg') {
        this.showMsgRemindAnim = true
        console.log('test::', '有新消息来了')
        this.$refs.chatMessage.refresh(args.args)
        if (!this.$refs.chatMessage.getOpenState()) {
          this.playAudio(true)
        }
      } else if (args.cmd === 'signOut') {
        let that = this
        this.$alert(that.$t('mainView.tips3'), that.$t('mainView.tips'), {
          confirmButtonText: that.$t('mainView.closePage'),
          callback: action => {
            that.close()
          }
        })
      } else if (args.cmd === 'startReissue') {
        this.startReissue(args.args)
      }
    },
    showBlankUserNotify () {
      if (!this.blankUserNotify) {
        this.closeBlankUserNotify()
        this.blankUserNotify = this.$notify.info({
          title: this.$t('mainView.tips'),
          message: this.$t('mainView.notUser'),
          duration: 0,
          showClose: false
        })
      }
    },
    closeBlankUserNotify () {
      if (this.blankUserNotify) {
        this.blankUserNotify.close()
        delete this.blankUserNotify
        this.blankUserNotify = null
      }
    },
    onChatSendMessage (userId, userType, msg, timestamp) {
      this.$refs.monitorService.sendMsg(userId, userType, msg, timestamp)
    },
    onFillMessage (userId, userType, list) {
      this.$refs.monitorService.fillMessage(userId, userType, list)
    },
    receiveData (args) {
      // console.log('fm::', '收到数据了', JSON.stringify(args))
      const data = args.data
      const length = this.$refs.fm.length
      for (let i = 0; i < length; i++) {
        const fmView = this.$refs.fm[i]
        if (fmView.data && fmView.data.userId === args.userId && fmView.data.userType === args.userType) {
          fmView.receiveData(JSON.parse(JSON.stringify(data)))
          this.drawWorker.postMessage({
            cmd: 'receiveData',
            args: {
              userId: fmView.data.userId,
              userType: fmView.data.userType,
              data: JSON.parse(JSON.stringify(data)),
              hasMove: true,
              display: true
            }
          })
        }
      }
    },
    startReissue (args) {
      const userId = args.userId
      const userType = args.userType
      console.log('reissue::', '收到补发开始请求，准备清理UI层', userId, userType)
      const length = this.$refs.fm.length
      for (let i = 0; i < length; i++) {
        const fmView = this.$refs.fm[i]
        if (fmView.data && fmView.data.userId === userId && fmView.data.userType === userType) {
          console.log('reissue::', '收到补发开始请求，清理UI层成功', userId, userType)
          fmView.startReissue()
          return
          // this.drawWorker.postMessage({
          //   cmd: 'receiveData',
          //   args: {userId: fmView.data.userId, userType: fmView.data.userType, data: JSON.parse(JSON.stringify(data)), hasMove: true, display: true}
          // })
        }
      }
      console.log('reissue::', '收到补发开始请求，清理UI层失败', userId, userType)
    },
    blankUsers () {
      const users = []
      for (let i = 0; i < this.pagination.pageSize; i++) {
        users.push({
          userId: i + 1,
          name: '',
          dueDate: '',
          weeks: '',
          state: 0,
          points: [],
          occupy: true
        })
      }
      return users
    },
    rowClick (row) {
      console.log('@rowClick', row)
      this.$refs.monitorService.clearUnRead(row.userId, row.userType)
      this.$refs.chatMessage.openChat(row.userId, row.userType, row.name, this.$refs.monitorService.getMessage(row.userId, row.userType))
      this.playAudio(false)
    },
    openChat (row) {
      // console.log('@chat', row)
      this.$refs.monitorService.clearNewUnRead(row.userId, row.userType)
      this.im.isShow = true
      this.$refs.im.openSession(row.chatId)
      this.playAudio(false)
    },
    refreshCurrentContact () {
      this.$refs.chatMessage.refreshCurrentContact()
    },
    getUserInfo (userId, userType, cb) {
      cb(this.$refs.monitorService.getMessage(userId, userType))
    },
    connect () {
      const that = this
      const webManageSystemUrl = process.env.VUE_APP_WEB_MANAGE_SYSTEM_URL
      // 找web系统要连接信息
      if (window.opener) {
        console.log('connect::', '找web系统要连接信息')
        window.opener.postMessage({cmd: 10000}, webManageSystemUrl)
        that.postState = false
      } else {
        // 如果与web系统失去关联，缓存有token则直接连
        const token = sessionStorage.getItem('service-token')
        if (token) {
          that.connectIM()
          console.log('connect::', 'token存在，发起连接')
          that.$refs.monitorService.connect(token)
        }
      }
      window.addEventListener('message', function (event) {
        console.log('chat', event)

        if (event.data) {
          if (event.data.cmd === 10001) {
            console.log('connect::', 'web系统告诉我用户信息了', event)
            console.log('connect::', webManageSystemUrl, event.origin)
            if (event.origin !== webManageSystemUrl) {
              that.$alert(this.$t('mainView.tips1'), this.$t('mainView.tips'), {
                confirmButtonText: this.$t('mainView.closePage'),
                callback: action => {
                  that.close()
                }
              })
            } else {
              that.postState = true
              sessionStorage.setItem('service-token', event.data.token)
              sessionStorage.setItem('service-user-type', event.data.userType)
              sessionStorage.setItem('service-chat-id', event.data.chatId)
              sessionStorage.setItem('service-chat-key', event.data.chatKey)
              sessionStorage.setItem('service-lang', event.data.lang)
              that.$i18n.locale = event.data.lang
              that.connectIM()
              console.log('connect::', '我有用户信息了，发起连接请求', event)
              that.$refs.monitorService.connect(event.data.token)
            }
          }
        }
      }, false)
      // 校验token是否失效
      setTimeout(function () {
        const token = sessionStorage.getItem('service-token')
        if (!token) {
          that.$alert(that.$t('mainView.tips2'), that.$t('mainView.tips'), {
            confirmButtonText: that.$t('mainView.closePage'),
            callback: action => {
              if (!window.opener) {
                window.open('about:blank', '_self').close()
              }
              that.close()
            }
          })
        } else {
          if (!that.postState) {
            that.connectIM()
            console.log('connect::', '找web要一直响应，利用缓存token发起连接')
            that.$refs.monitorService.connect(token)
          }
        }
      }, 3000)
    },
    close () {
      if (window._isInElectron) {
        window._sendToElectron('close-window', {id: 'monitor-window'})
      } else {
        window.close()
      }
    },
    playAudio (isPlay) {
      if (window._isInElectron) {
        window._sendToElectron('message-audio', {
          cmd: isPlay ? 'start' : 'stop'
        })
      }
    },
    openContact (row) {
      this.$refs.contactInfo.show(row)
    },
    connectIM () {
      const token = sessionStorage.getItem('service-token')
      const chatId = sessionStorage.getItem('service-chat-id')
      const chatKey = sessionStorage.getItem('service-chat-key')

      if (token && chatId && chatKey) {
        this.im.isLoad = true
        this.$nextTick(() => {
          this.$refs.im.login(token, chatId, chatKey)
        })
      }
    },
    imClosed () {
      this.im.isShow = false
    },
    imNewMessage (userInfo) {
      // userInfo.unReadCount = Math.floor((Math.random() * 2) + 0)
      console.log('@@message', userInfo)
      this.showMsgRemindAnim = true
      if (this.im.isLoad) {
        if (userInfo.activeSession !== userInfo.sessionId) {
          // 当有新消息通知过来时，如果跟当前已经打开的会话窗口不是同一个人
          // 并且本地有该用户，则显示红点和声音提醒
          if (this.$refs.monitorService.receiveNewMsg(userInfo.userId, userInfo.userType, userInfo.unReadCount)) {
            // if (!this.im.isShow) {
            this.playAudio(true)
            // }
          }
        }
      }
    },
    getOnlineUsers () {
      return this.$refs.monitorService.getOnlineUsers()
    },
    checkAlarm () {
      // 如果没有在线用户了，或者在线用户中没有需要fhr报警的，则关闭报警
      let state = false
      const length = this.users.length
      for (let i = 0; i < length; i++) {
        if (this.users[i].alarm && this.users[i].alarm.fhr && this.users[i].alarm.fhr.state) {
          state = true
        }
      }
      if (!state) {
        this.playAlarmAudio(false)
      }
    },
    playAlarmAudio (isPlay) {
      if (window._isInElectron) {
        window._sendToElectron('alarm-fhr-audio', {
          cmd: isPlay ? 'start' : 'stop'
        })
      }
    }
  },
  destroyed () {
    // this.stopReceiveData()

    if (this.drawWorker) {
      this.drawWorker.postMessage({cmd: 'close'})
      this.drawWorker.terminate()
      delete this.drawWorker
      this.drawWorker = null
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body, div {
  margin: 0;
  padding: 0;
  border: 0;
}

.container {
  background: #3e3e3e;
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
}

.monitor {
  flex-grow: 1;
  flex-shrink: 1;
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  align-content: flex-start;
}

.monitor::-webkit-scrollbar {
  display: none;
}

.copyright {
  height: var(--height);
  line-height: var(--height);
  background: #4bb7b7;
  display: flex;
}

.company {
  padding-left: 20px;
  flex: 1;

  color: #fff;
  font-family: 黑体, serif;
  font-size: 12px;
}

.paging {
  padding-right: 20px;
}

.tools {
  padding-right: 20px;
}

.tools svg {
  color: #fff;
  margin-left: 5px;
  font-size: 18px;
  cursor: pointer;
  vertical-align: -0.1em;
  outline: none;
}

.tools .user-list {
  animation: color-change 1s infinite ease-in-out;
}

@keyframes color-change {
  0% {
    color: #e56161;
  }
  100% {
    color: #ffffff;
  }
}
</style>

<style scoped lang="scss">
::v-deep .paging .el-pagination {
  .btn-prev {
    background: center center no-repeat #4bb7b7;
    background-size: 16px;
    cursor: pointer;
    margin: 0;
    color: #fff;
  }
}

::v-deep .paging .el-pagination {
  .btn-next {
    background: center center no-repeat #4bb7b7;
    background-size: 16px;
    cursor: pointer;
    margin: 0;
    color: #fff;
  }
}

::v-deep .paging .el-pagination {
  button:disabled {
    color: #C0C4CC;
    background-color: #4bb7b7;
    cursor: not-allowed;
  }
}

::v-deep .paging {
  .el-dialog {
    background: #4bb7b7;
  }
}

::v-deep .paging .el-pager {
  li {
    background: #4bb7b7;
  }
}

::v-deep .paging .el-pagination {
  white-space: nowrap;
  padding: 2px 5px;
  color: #fff;
  font-weight: 700;
}

::v-deep .paging .el-pager {
  li.btn-quicknext {
    line-height: 28px;
    color: #fff;
  }
}

::v-deep .paging .el-pager {
  li.btn-quickprev {
    line-height: 28px;
    color: #fff;
  }
}
</style>
